const Novu = {
  APP_ID: `${import.meta.env.VITE_NOVU_APP_ID}`,
  NOVU_SOCKET_URL: `${import.meta.env.VITE_NOVU_SOCKET_URL}`,
  NOVU_BACKEND_URL: `${import.meta.env.VITE_NOVU_BACKEND_URL}`
};

export default Novu;
